/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function ArrowDown(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <rect
                        fill='none'
                        height='26'
                        id='canvas_background'
                        width='26'
                        x='-1'
                        y='-1'
                    />
                </g>
                <g fill={iconColor || '#000'}>
                    <path
                        d='m23.38189,12.04681l-2.002663,-2.017383l-7.939282,7.983686l0,-17.412805l-2.841012,0l0,17.412805l-7.925434,-7.997636l-2.016512,2.031333l11.362984,11.446502l11.362984,-11.446502l-0.001065,0z'
                        id='svg_1'
                        stroke='null'
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}